module.exports = __webpack_public_path__ + "static/media/logo_text-only.5366b0f1.png";